import { getManageableManagerIds, isSuperManager } from '../../modules/logic/managerScope';
import { doGet, doPost } from '../../modules/DataManager';
import { getGlobalState } from '../../store';
import { setManagers } from '../slices/crudListSlices';
import { setCurrentManager } from '../slices/singletonSlices';

const ADMIN_ROLES = ['admin', 'super', 'administrative'];

// Requests out right now, shared by concurrent callers (several pages mount
// at once and each asks for the list).
let pendingFetch = null;

/**
 * Loads `state.managers`. When Redux already holds them nothing is requested;
 * `force` reloads after a change (create/edit/delete, manager page save).
 */
export const fetchManagers = ({ force = false } = {}) => {
  return async (dispatch, getState) => {
    const current = (getState ?? getGlobalState)()?.managers;
    if (!force && Array.isArray(current) && current.length > 0) return;
    // A forced reload follows a change: a request started before it is stale.
    if (pendingFetch && !force) return pendingFetch;
    const request = loadManagers(dispatch).finally(() => {
      if (pendingFetch === request) pendingFetch = null;
    });
    pendingFetch = request;
    return request;
  };
};

const loadManagers = async (dispatch) => {
  try {
    const state = getGlobalState();
    const isAdmin = ADMIN_ROLES.includes(state.role);

    // Admin MBILITY → tutti; super gestore → proprio + associati; gestore
    // normale → solo il proprio.
    let params = {};
    if (!isAdmin) {
      if (isSuperManager(state.currentManager)) {
        params = { manager_ids: getManageableManagerIds(state) };
      } else {
        const managerId = state.user?.gestore || state.user?.id_gestore;
        params = managerId ? { manager_id: managerId } : {};
      }
    }

    const res = await doGet('/v2/managers/get-managers', params);

    const managers = Array.isArray(res) ? res.filter((m) => !m.deleted) : [];

    dispatch(setManagers(managers));
  } catch (error) {
    console.error('Error loading managers:', error);
  }
};

export const createManager = (manager) => {
  return async (dispatch) => {
    try {
      await doPost('/v2/managers/add-manager', manager);
      dispatch(fetchManagers({ force: true }));
    } catch (error) {
      console.error('Errore nella creazione del gestore:', error);
    }
  };
};

export const editManager = (manager) => {
  return async (dispatch) => {
    try {
      await doPost('/v2/managers/edit-manager', manager);
      dispatch(fetchManagers({ force: true }));
    } catch (error) {
      console.error('Errore nell’aggiornamento del gestore:', error);
    }
  };
};

export const removeManager = (id) => {
  return async (dispatch) => {
    try {
      await doPost('/v2/managers/delete-manager', { id });
      dispatch(fetchManagers({ force: true }));
    } catch (error) {
      console.error('Errore nella cancellazione del gestore:', error);
    }
  };
};

export const fetchCurrentManager = (id) => async (dispatch) => {
  try {
    const res = await doGet(`/v2/managers/get-manager-by-id`, { id });
    dispatch(setCurrentManager(res));
  } catch (error) {
    console.error('Error loading current manager:', error);
  }
};
